import React from 'react'
import './Modal.scss'

interface ModalProps {
  children: React.ReactNode
  style?: React.CSSProperties
  className: string
}

const Modal: React.FC<ModalProps> = ({ children, className }) => {
  return (
    <div className={`ModalWrapper ${className}`}>
      <div className='ModalContent'>
        {children}
      </div>
    </div>
  )
}

export default Modal
